import Immutable from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';
import { SheetQuery } from 'records/SheetQuery';
import querySheets from 'utils/querySheets';

export interface SheetQueryActions {
  setSheetQuery: (
    actionParams: AppStateActionParams,
    nextSheetQuery: SheetQuery
  ) => AppState;

  querySheets: (actionParams: AppStateActionParams) => AppState;
  initSheetQuery: (actionParams: AppStateActionParams) => AppState;
}

const sheetQueryActions: SheetQueryActions = {
  setSheetQuery: (
    { state }: AppStateActionParams,
    nextSheetQuery: SheetQuery
  ): AppState => {
    const { sheets } = state();

    const qSheets = querySheets(sheets, nextSheetQuery).keySeq().toList();

    return state()
      .set('sheetQuery', nextSheetQuery)
      .set('queriedSheets', qSheets);
  },

  querySheets: ({ state }: AppStateActionParams): AppState => {
    const { sheets, sheetQuery } = state();

    const qSheets = querySheets(sheets, sheetQuery);
    const queriedSheets = Immutable.List(qSheets.keys());

    return state().set('queriedSheets', queriedSheets);
  },

  initSheetQuery: ({ state }: AppStateActionParams): AppState => {
    const { sheets } = state();
    const sheetQuery = new SheetQuery()
      .set('sortField', 'discipline')
      .set('initialized', true);

    const qSheets = querySheets(sheets, sheetQuery);

    return state()
      .set('sheetQuery', sheetQuery)
      .set('queriedSheets', Immutable.List(qSheets.keys()));
  },
};

export default sheetQueryActions;
